export enum SESSION_STORAGE_KEYS {
  ACCESS_TOKEN = 'accessToken',
}
